import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

const CUSTOMER_SUPPORT_NUMBER = "+448000321196";

export interface IDockedButtonProps {
  primaryButtonOnClick: () => void;
  primaryButtonDisabled?: boolean;
  primaryButtonLabel: string;
  className?: string;
  secondaryButtonOnClick?: () => void;
  secondaryButtonLabel?: string;
}

export const DockedButton = ({
  primaryButtonOnClick,
  primaryButtonDisabled = false,
  primaryButtonLabel,
  className,
  secondaryButtonOnClick,
  secondaryButtonLabel,
}: IDockedButtonProps) => {
  const [block, cn] = useModuleBEM(styles, "DockedButton");
  const { t } = useI18nContext();
  const contactSupport = () => {
    window.location.href = `tel:${CUSTOMER_SUPPORT_NUMBER}`;
  };

  return (
    <div className={clsx(block, className)}>
      <Button
        className={cn("secondary-button")}
        buttonType={ButtonTypeEnum.Secondary}
        onClick={secondaryButtonOnClick ?? contactSupport}
      >
        {secondaryButtonLabel ??
          t("core-flights.rebook.summary.contact-support-button")}
      </Button>
      <Button
        className={cn("primary-button")}
        buttonType={ButtonTypeEnum.Primary}
        disabled={primaryButtonDisabled}
        onClick={primaryButtonOnClick}
      >
        {primaryButtonLabel}
      </Button>
    </div>
  );
};
